import {
  updateConsultState,
  emptyConsultState,
  getConsultState,
} from '@/services/consultService';
import { defineStore } from 'pinia';

export const useConsultStore = defineStore('consult', {
  state: () => ({
    consultState: {},
    consultSteps: ['signIn', 'postSignIn'],
  }),
  actions: {
    initialSetUp() {
      this.updateConsult({
        ...getConsultState(),
      });
    },
    updateConsult(payload) {
      updateConsultState({ ...payload });

      this.consultState = payload;
    },
    removeConsult() {
      this.consultState = { step: 0 };
      emptyConsultState();
    },
    nextConsultStep() {
      const currentStep = this.consultSteps.findIndex(
        (item) => item === this.consultState.stage
      );

      this.updateConsult({
        ...this.consultState,
        stage: this.consultSteps[currentStep + 1],
      });
    },
  },
});
